import { ReactElement, ReactNode } from 'react'
import { changeSummaryTextOfPre } from '../changeSummary'
import ChangeSummaryCard from './ChangeSummaryCard'

interface Props {
  children?: ReactNode
  // Streamdown passes the hast node to every element renderer.
  node?: unknown
}

/**
 * Code blocks in chat answers: the agent's `changes` block becomes the
 * "Vorgenommene Änderungen" card; every other block renders as Streamdown's
 * own `pre` does (just its code element).
 */
const ChatPre = ({ children, node }: Props): ReactElement => {
  const changeSummary = changeSummaryTextOfPre(node)
  if (changeSummary !== null) return <ChangeSummaryCard text={changeSummary} />

  return <>{children}</>
}

export default ChatPre
